/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
type State = Object;
import { LIBRARIES_FETCH_SUCCESS, LIBRARIES_FETCH_FAIL, LIBRARY_CREATED } from '../types';
import { FETCHING, CREATE, UPLOAD, FETCH_FAIL } from '../components/QuickActions/constants';

const initialState: {
	library: object;
	status: string;
} = {
	library: {},
	status: FETCHING,
};

export default (state: State = initialState, action: SaveToLibraryAction) => {
	switch (action.type) {
		case LIBRARIES_FETCH_SUCCESS: {
			let mylibrary;
			let lib;
			for (lib of action.payload) {
				if (lib.name == 'My Library') {
					mylibrary = lib;
					break;
				}
			}
			if (!mylibrary) {
				// lib with name My library does not exist
				//we set status to create and upload
				return { ...state, status: CREATE };
			} else {
				//we set status to upload
				return { library: { ...mylibrary }, status: UPLOAD };
			}
		}
		case LIBRARIES_FETCH_FAIL: {
			//we set status to fail
			return { ...state, status: FETCH_FAIL };
		}
		case LIBRARY_CREATED: {
			//set the created library
			return { library: { ...action.payload }, status: UPLOAD };
		}
		default:
			return state;
	}
};
